import React, { useEffect } from "react"
import './index.less'
import { Button, Table, Checkbox, Popover } from 'antd';
import { fileHttpUrl } from "@api/baseUrl";
import ProForm, {
    ProFormText,
    ProFormUploadDragger,
    ProFormSelect,
    ProFormTextArea,
    ProFormDependency,
    ProFormRadio,
    ProFormProps
} from '@ant-design/pro-form';
import Animation from "@common/Animation"
import { CarouselImg } from "@components/Home/AboutUs/CarouselImg";
import { Icon } from "@components/index";
import { GoRegister } from "../PageIndex";
import { StateType } from "@store/index";
import { useSelector } from "react-redux";

const TopDiv = () => {
    return (<div className="top-div" style={{ background: `url(${fileHttpUrl('fileServer/2022/11/07/bd8040e2cd1445e8927c5d7df9a5d923.png')}) no-repeat` }} >
        <div className="title">关于我们</div>
        <div className="mt-8">努力成为云市场最丰富的、最开放的API、SaaS、PaaS集成平台；</div>
        <div className="">为合作伙伴构建基于灿星云产品的成功业务实践和解决方案。</div>
    </div>)
}

const Introduce = () => {
    return (<div className="introduce divCard">
        <div className="home-aboutus-itemTitle">
            企业介绍 / <span>COMPANIES TO INTRODU</span>
        </div>
        <div className="content">
            <div className="flex justify-around">
                <div>
                    <div className="text-red-500 text-4xl font-semibold text-center"><Animation.NumberRoll>{10000}</Animation.NumberRoll>+</div>
                    <div className="text-center mt-4 font-semibold">企业用户和开发者</div>
                </div>
                <div>
                    <div className="text-red-500 text-4xl font-semibold text-center"><Animation.NumberRoll>{1000}</Animation.NumberRoll>万+</div>
                    <div className="text-center mt-4 font-semibold">云服务受益网民</div>
                </div>
                <div>
                    <div className="text-red-500 text-4xl font-semibold text-center"><Animation.NumberRoll>{10000}</Animation.NumberRoll>+</div>
                    <div className="text-center mt-4 font-semibold">云服务行业解决方案</div>
                </div>
            </div>
            <div className="mt-4 text-base mt-10 leading-9">
                灿星云秉持“数字化从未如此简单”的客户服务理念，帮助企业便捷、高效地解决数字化问题。主营产品是向企业客户提供以消息通信服务为基础，融合大数据的通信综合解决方案。我司已与多家国有数据资产增值运营服务商建立了战略合作，最大程度保障用户使用数据的安全性与稳定性。
                公司核心团队自2018年起参与建立数据归集、数据治理、数据开放和应用、数据安全防护的数据技术研发。因多年的积累，在数据和接口服务方面驾轻就熟，得到了广大用户的高度认可。随着平台技术不断成熟，技术团队还可以根据用户需求，提供SaaS和PaaS服务，以及提供更多的软开方面的咨询和服务。
            </div>
        </div>
    </div>)
}

const Environment = () => {
    return (<div className="environment divCard">
        <div className="home-aboutus-itemTitle ">
            公司环境 / <span>COMPANY ENVIRONMENT</span>
        </div>
        <div className="imgDiv mt-6">
             <CarouselImg />
        </div>
    </div>)
}

const Culture = () => {
    return (<div className="divCard culture">
        <div className="home-aboutus-itemTitle">
            企业文化 / <span>ERTERPRISE CULTURE</span>
        </div>
        <div className="flex justify-between">
            <div className="cardDiv">
                <img src={fileHttpUrl("fileServer/2022/11/07/f0259bdae4ca43dea9b33002d874a7f4.png")} className='item' alt="灿星云愿景" />
                <div className="title">灿星云愿景</div>
                <div className="text">做最开放的API、SaaS、PaaS集成平台。</div>
            </div>
            <div className="cardDiv">
                <img src={fileHttpUrl("fileServer/2022/11/07/ce1ffa1876aa4e66880702f36979b96f.png")} className='item' alt="灿星云使命" />
                <div className="title">灿星云使命</div>
                <div className="text">一站式全场景，助力企业全方位效能提升。</div>
            </div>
            <div className="cardDiv">
                <img src={fileHttpUrl("fileServer/2022/11/07/a483a430d9e5457e88925eb76ead7ddc.png")} className='item' alt="服务理念" />
                <div className="title">服务理念</div>
                <div className="text">高效、安全、可靠，一切只为更好的服务。</div>
            </div>
        </div>
    </div>)
}

const ContactUs = () => {
    return (<div className="divCard contactUs">
        <div className="home-aboutus-itemTitle">
            联系我们 / <span>CONTACT US</span>
        </div>
        <div className="flex justify-between">
            <div className="left">
                <div><Icon type="icon-gongsiguanli" />公司：杭州云栖灿星科技有限公司</div>
                <div><Icon type="icon-31dianhua" />电话：18142066194</div>
                <div><Icon type="icon-dizhiguanli" />地址:  杭州市西湖区黄姑山路29号颐高创业大厦5楼</div>
                <div><Icon type="icon-youxiang" />邮箱:  service@cxlnk.com</div>
                <img src={fileHttpUrl("fileServer/2022/11/22/548bc79bce1c430ca06ae2fe38f55af5.png")} className='mt-6' alt="灿星云" />
                
            </div>
            <div className="">
                <img src={fileHttpUrl("fileServer/2022/11/22/10f0078702564f92a5d7483174390b21.jpg")} className='mt-6' alt="灿星云" />
            </div>
        </div>
    </div>)
}


export default () => {
    const { isnull, ueSaasAboutUs } = useSelector((state: StateType) => state.domainInfo) as any;
    return (<div className="j-home-aboutUs">
        {/* 关于我们页面先用 isnull判断是不是灿星云，1 的话就是灿星云，就用咱们写死的关于我们页面，非1的话就用传进来的富文本内容填充页面 */}
        {(!isnull && ueSaasAboutUs) ? <div dangerouslySetInnerHTML={{ __html: ueSaasAboutUs }}></div> : 
            <div>
                {/* 上部分的组件 */}
                <TopDiv />
                {/* 企业介绍 */}
                <Introduce />
                {/* 企业环境 */}
                <Environment />
                {/* 企业文化 */}
                <Culture />
                {/* 联系我们 */}
                <ContactUs />
                {/* 注册引导 */}
                <GoRegister />
            </div>
        }
       
    </div>)
}